(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 6102:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(1714);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7458);
/* harmony import */ var lib_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(488);
/* harmony import */ var _lagon_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8566);



const FunctionLinks = (param)=>{
    let { func  } = param;
    if (!func) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex gap-4 overflow-x-scroll md:overflow-x-auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lagon_ui__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
                href: (0,lib_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFullCurrentDomain */ .iX)(func),
                target: "_blank",
                children: (0,lib_utils__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentDomain */ .ZR)(func)
            }),
            func.domains.map((domain)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lagon_ui__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
                    href: (0,lib_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFullDomain */ .VQ)(domain),
                    target: "_blank",
                    children: domain
                }, domain))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FunctionLinks);


/***/ }),

/***/ 9549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7458);
/* harmony import */ var _lagon_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8566);


const LayoutTitle = (param)=>{
    let { title , titleStatus , rightItem , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mx-auto px-4 md:max-w-4xl",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex justify-between items-center pt-10 mb-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_lagon_ui__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                        size: "2xl",
                        children: [
                            titleStatus ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lagon_ui__WEBPACK_IMPORTED_MODULE_1__/* .Dot */ .oT, {
                                status: titleStatus
                            }) : null,
                            title
                        ]
                    }),
                    rightItem
                ]
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LayoutTitle);


/***/ }),

/***/ 1714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(7458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(2983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.6_biqbaboplfbrettd7655fr4n2y/node_modules/next/router.js
var next_router = __webpack_require__(64);
// EXTERNAL MODULE: ./lib/components/FunctionLinks.tsx
var FunctionLinks = __webpack_require__(4858);
// EXTERNAL MODULE: ./lib/trpc.ts + 46 modules
var trpc = __webpack_require__(8793);
;// CONCATENATED MODULE: ./lib/hooks/useFunctions.ts

const useFunctions = ()=>{
    return trpc/* trpc.functionsList.useQuery */.S.functionsList.useQuery();
};
/* harmony default export */ var hooks_useFunctions = (useFunctions);

// EXTERNAL MODULE: ../ui/src/index.ts + 87 modules
var src = __webpack_require__(8566);
// EXTERNAL MODULE: ./locales/index.ts
var locales = __webpack_require__(2325);
;// CONCATENATED MODULE: ./lib/pages/functions/FunctionsList.tsx







const FunctionsList = ()=>{
    const { data: functions  } = hooks_useFunctions();
    const { push  } = (0,next_router.useRouter)();
    const { scopedT  } = (0,locales/* useI18n */.QT)();
    const t = scopedT("home");
    const navigateToFunction = (0,react.useCallback)((functionId)=>{
        push("/functions/".concat(functionId));
    }, [
        push
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex gap-4 flex-col",
        children: [
            (functions === null || functions === void 0 ? void 0 : functions.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* EmptyState */.ub, {
                title: t("empty.title"),
                description: t("empty.description")
            }) : null,
            functions === null || functions === void 0 ? void 0 : functions.map((func)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* Card */.Zb, {
                    clickable: true,
                    onClick: ()=>navigateToFunction(func.id),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between items-start whitespace-nowrap gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* Text */.xv, {
                                    size: "lg",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Dot */.oT, {
                                            status: "success"
                                        }),
                                        func.name
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FunctionLinks/* default */.Z, {
                                    func: func
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* Text */.xv, {
                            size: "sm",
                            children: [
                                t("list.lastUpdate"),
                                "\xa0",
                                new Date(func.updatedAt).toLocaleString("en-US", {
                                    minute: "numeric",
                                    hour: "numeric",
                                    day: "numeric",
                                    month: "long",
                                    year: "numeric"
                                })
                            ]
                        })
                    ]
                }, func.id))
        ]
    });
};
/* harmony default export */ var functions_FunctionsList = (FunctionsList);

// EXTERNAL MODULE: ./lib/components/LayoutTitle.tsx
var LayoutTitle = __webpack_require__(9549);
;// CONCATENATED MODULE: ./pages/index.tsx








const Home = ()=>{
    const createFunction = trpc/* trpc.functionCreate.useMutation */.S.functionCreate.useMutation();
    const createDeployment = trpc/* trpc.deploymentCreate.useMutation */.S.deploymentCreate.useMutation();
    const deployDeployment = trpc/* trpc.deploymentDeploy.useMutation */.S.deploymentDeploy.useMutation();
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const router = (0,next_router.useRouter)();
    const { scopedT  } = (0,locales/* useI18n */.QT)();
    const t = scopedT("home");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutTitle/* default */.Z, {
        title: t("title"),
        rightItem: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Button */.zx, {
            variant: "primary",
            disabled: isLoading,
            onClick: async ()=>{
                setIsLoading(true);
                const func = await createFunction.mutateAsync({
                    domains: [],
                    env: [],
                    cron: null
                });
                const deployment = await createDeployment.mutateAsync({
                    functionId: func.id,
                    assets: []
                });
                await fetch(deployment.codeUrl, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "text/javascript"
                    },
                    body: 'export function handler(request) {\n  return new Response("Hello World!")\n}'
                });
                await deployDeployment.mutateAsync({
                    functionId: func.id,
                    deploymentId: deployment.deploymentId,
                    isProduction: true
                });
                setIsLoading(false);
                router.push("/playground/".concat(func.id));
            },
            children: t("createFunction")
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Skeleton */.Od, {
                variant: "card"
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(functions_FunctionsList, {})
        })
    });
};
Home.title = "Functions";
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(6102); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);